import React, { useState, useRef, useEffect } from "react";
import { useFormCtx } from "./FormContext";
import dateFormat from "dateformat";
import Navbar from "./components/Navbar";
import Button from "./components/Button";
import Transition from "./components/Transition";
import useMqttClient from "./hooks/useMqttClient";
import ScaleSpinnerProgressSection from "./components/ScaleSpinnerProgressSection";
import * as Const from "./_Const";
import useScreenType from "./hooks/useScreenType";
import HiddenMenuBar from "./components/HiddenMenuBar";

import * as TerminalAppService from "./services/data/TerminalAppService";

const remove_understand = "ROZUMÍM";
const remove_thank = "DĚKUJEME";
const remove_card_title = "Vyjměte průkaz!";

const remove_activity_without_card_title = "Váš identifikační kód";
const remove_activity_without_card_code_title = "Tento KÓD si zapamatujte";
const remove_activity_without_card_subtitle = "Posaďte se, budete volán jako";

const remove_title = "Odeberte průkaz totožnosti";
const remove_subtitle = "ze zařízení a posaďte se";
const navbar_title = "Registrace úspěšně dokončena";
const navbar_title_progress = "Probíhá dokončování registrace...";

function PageRemoveCard() {
  const screenType = useScreenType();
  const { navigateHome, state, isEmptyState, isTaskRunning, lastError, axiosTerminalAppInstance, beep } = useFormCtx();
  const { isConnected, messages, publish, lastMessage } = useMqttClient(Const.TERMINAL_APP_SERVICE_WEB_SOCKET_URL, Const.TOPIC_MQTTT_LOCAL);
  const [lastProcessedMessage, setLastProcessedMessage] = useState(null);
  const [isCardInside, setIsCardInside] = useState(false);

  const showProgress = isTaskRunning ? true : false;
  //chybove stavy me nezajimaji, maximalne se to nastavi rucne na serveru, tak ze s zobrazi summary i kdyz lastError neni 0
  const showSummary = !showProgress /*&& lastError === 0*/ ? true : false;
  const isWithoutCard = state?.isWithoutCard ?? false;
  const closeAfter = isWithoutCard ? Const.PAGE_REG_SUMMARY_TERMINAL_TIME : 3000;
  const card_message = !isWithoutCard ? (isCardInside ? remove_card_title : remove_thank) : "";

  const timerIdRef = useRef(null);
  const isTerminal = Const.isTerminal();

  useEffect(() => {
    function runAfterLoad() {
      timerIdRef.current = setTimeout(async () => {
        if (isWithoutCard) {
          beep();
          navigateHome();
        } else {
          await getIsCardInside();
        }
        console.log(`End of remove card page after interval ${closeAfter}`);
      }, closeAfter);
    }

    runAfterLoad();

    return () => {
      if (timerIdRef?.current) {
        clearTimeout(timerIdRef.current);
        console.log("clearing remove card page timeout");
      }
    };
  }, []);

  useEffect(() => {
    if (lastMessage) {
      //zavolam to abych stanovil state
      if (!isWithoutCard) {
        handleMqttMessage(lastMessage);
      }
    }
  }, [lastMessage]);

  async function handleMqttMessage(newMessage) {
    //console.log("handleMqttMessage", newMessage, lastProcessedMessage);
    //nezpracovavat stejnou message vicekrat
    if (lastProcessedMessage !== newMessage) {
      setLastProcessedMessage(newMessage);
      console.log(new Date().toISOString(), "handleMqttMessage", newMessage, state);

      // Speciální logika pro téma RPi
      if (newMessage?.topic === Const.TOPIC_MQTTT_LOCAL) {
        if (newMessage.payload === Const.LOCAL_MESSAGE_CARD_REMOVED) {
          console.log("Prukaz vytažen ok", state);
          beep();
          navigateHome();
        }
      }
    }
  }

  async function getIsCardInside() {
    console.log(new Date().toISOString(), "getIsCardInside() from rpi", state);
    //send(ACTION_GET_PHOTO);

    try {
      let { data } = await TerminalAppService.getIsCardInside(axiosTerminalAppInstance);
      //console.log(data);

      if (!data.isError) {
        const isCardNowInside = data?.data?.isCardInside ?? false;
        console.log("Stav detektoru isCardInside:", isCardNowInside);
        setIsCardInside(isCardNowInside);
        beep();
        if (!isCardNowInside) {
          navigateHome();
        }
      } else {
        console.log("Chyba při zjišťování stavu detektoru", data.message);
      }
    } catch (ex) {
      console.log("Chyba při zjišťování stavu detektoru", ex);
    }
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "parent-div":
          css = "mt-8";
          break;
        case "title":
          css = "text-3xl";
          break;
        case "subtitle":
          css = "text-xl mt-0";
          break;
        case "message":
          css = "text-7xl mt-8";
          break;
        case "message-subtitle":
          css = "text-xl mt-4";
          break;
        case "btn":
          css = "h-[72px] min-w-52 text-xl";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "parent-div":
          css = "mt-12";
          break;
        case "title":
          css = "text-6xl";
          break;
        case "subtitle":
          css = "text-5xl mt-4 ";
          break;
        case "message":
          css = "text-[110px] mt-4";
          break;
        case "message-subtitle":
          css = "text-4xl";
          break;
        case "btn":
          css = "h-20 min-w-80 text-3xl";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "parent-div":
          css = "mt-12";
          break;
        case "title":
          css = "text-6xl";
          break;
        case "subtitle":
          css = "text-5xl mt-4 ";
          break;
        case "message":
          css = "text-[110px] mt-8";
          break;
        case "message-subtitle":
          css = "text-4xl";
          break;
        case "btn":
          css = "h-20 min-w-80 text-3xl";
          break;
      }
    }

    //console.log(what, screenType, css);

    return css;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  return (
    <>
      <div className="flex flex-col h-dvh overflow-hidden">
        <div className="flex-1 overflow-y-scroll pb-6 overflow-x-hidden">
          <Navbar customTitle={showProgress ? navbar_title_progress : navbar_title} modeShowTitle={true} modeShowSubtitle={false} useCustomTitle={true} />
          <Transition exit="none" initial="none">
            {showSummary && (
              <div className="container mx-auto">
                <div className={`${getCssFor("parent-div")}`}>
                  {isWithoutCard && (
                    <>
                      <p className={`${getCssFor("title")} text-accent text-center mt-0`}>{remove_activity_without_card_subtitle}</p>
                    </>
                  )}
                  {!isWithoutCard && (
                    <>
                      <p className={`${getCssFor("title")} text-accent text-center mt-0`}>{remove_title}</p>
                      <p className={`${getCssFor("subtitle")} text-accent text-center`}>{remove_subtitle}</p>
                    </>
                  )}
                </div>
                <div className="absolute top-1/2 left-1/2 w-full -translate-y-1/2 -translate-x-1/2 ">
                  {isWithoutCard && (
                    <>
                      <p className={`${getCssFor("message")} text-error-dark text-center uppercase`}>{`Pacient ${state.identification}`}</p>
                      <p className={`${getCssFor("message-subtitle")} text-primary text-center`}>{remove_activity_without_card_code_title}</p>
                    </>
                  )}
                  {!isWithoutCard && <p className={`${getCssFor("message")} text-error-dark text-center uppercase`}>{card_message}</p>}
                </div>
              </div>
            )}

            {showProgress && <ScaleSpinnerProgressSection />}
          </Transition>
        </div>

        {showSummary && isWithoutCard && (
          <footer className="">
            <div className="grid place-content-center">
              <div className="col-span-3 w-full mb-4">
                <Button
                  type="terminal-dark"
                  title={remove_understand}
                  className={`${getCssFor("btn")} rounded-none`}
                  showIcon={false}
                  onClick={() => navigateHome()}
                />
              </div>
            </div>
          </footer>
        )}
        {isTerminal && <HiddenMenuBar />}
      </div>
    </>
  );
}

export default PageRemoveCard;
